import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { TaisaCoreLogo } from './ui';
import './LoginPage.css';

const LoginPage = ({ onLoginSuccess }) => {
  const { login, error } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [localError, setLocalError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLocalError('');

    if (!email || !password) {
      setLocalError('נא להזין אימייל וסיסמה');
      return;
    }

    setIsSubmitting(true);
    const result = await login(email, password);
    setIsSubmitting(false);

    if (result.success) {
      onLoginSuccess && onLoginSuccess(result.user);
    } else {
      setLocalError(result.error);
    }
  };

  return (
    <div className="login-page">
      {/* Animated Background */}
      <div className="login-background">
        <div className="bg-grid"></div>
        <div className="bg-glow glow-1"></div>
        <div className="bg-glow glow-2"></div>

        {/* Floating particles */}
        <div className="particles">
          {[...Array(20)].map((_, i) => (
            <span
              key={i}
              className="particle"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${10 + Math.random() * 10}s`
              }}
            />
          ))}
        </div>
      </div>

      {/* Login Card */}
      <div className="login-card">
        {/* Logo Section - BLACK background */}
        <div className="login-logo-section">
          <TaisaCoreLogo size="xlarge" animated={true} withBackground={false} />
        </div>

        {/* Title */}
        <div className="login-header">
          <h1 className="clinic-name">Yahalomi</h1>
          <p className="clinic-name-he">יהלומי</p>
          <p className="login-subtitle">מערכת ניהול מרפאה חכמה</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="login-form">
          {/* Error Message */}
          {(localError || error) && (
            <div className="login-error">
              <span className="error-icon">&#9888;</span>
              <span>{localError || error}</span>
            </div>
          )}

          {/* Email Field */}
          <div className="form-group">
            <label htmlFor="email">
              <span className="label-icon">&#9993;</span>
              <span>אימייל</span>
            </label>
            <div className="input-wrapper">
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                autoComplete="email"
                disabled={isSubmitting}
                dir="ltr"
              />
            </div>
          </div>

          {/* Password Field */}
          <div className="form-group">
            <label htmlFor="password">
              <span className="label-icon">&#128274;</span>
              <span>סיסמה</span>
            </label>
            <div className="input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="********"
                autoComplete="current-password"
                disabled={isSubmitting}
                dir="ltr"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
              >
                {showPassword ? '&#128584;' : '&#128065;'}
              </button>
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className={`login-button ${isSubmitting ? 'loading' : ''}`}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="spinner"></span>
                <span>מתחבר...</span>
              </>
            ) : (
              <>
                <span>התחבר</span>
                <span className="arrow">&#8594;</span>
              </>
            )}
          </button>

          {/* Forgot Password Link */}
          <div className="login-footer">
            <button type="button" className="forgot-link">שכחת סיסמה?</button>
          </div>
        </form>

        {/* Powered By */}
        <div className="powered-by">
          <span>powered by</span>
          <strong>TaisaCore</strong>
        </div>
      </div>

      {/* Version */}
      <div className="version-tag">v1.0.0</div>
    </div>
  );
};

export default LoginPage;
